<template>
  <div>
    <div class="d-print-none">
      <p class="fs-lg font-weight-bold">
        <b-icon class="mr-1" icon="info-circle" />
        Je potrebné, aby ste zadali cenu silovej elektriny a mesačnú platbu
        Vášho dodávateľa. Pri zadávaní dodržujte správne jednotky a jednotkové
        ceny.
      </p>
      <p>
        Vašu presnú spotrebu nájdete v aplikácií IS ESM v záložke „Dáta“ –
        fakturačné dáta alebo na ročnom vyúčtovaní Vášho dodávateľa. Ak
        dostávate mesačné vyúčtovanie, nezabudnite spotrebu sčítať za celý
        kalendárny rok.
      </p>
      <p>Kalkulačka počíta vždy s cenami aktuálneho roka.</p>
      <p>
        Odporúčaná výška zálohovej platby je orientačná, stále sa viete dohodnúť
        na výške a počte záloh s Vašim dodávateľom.
      </p>
    </div>
    <b-row>
      <b-col md="6">
        <b-card class="mb-4" no-body>
          <b-card-body>
            <table
              class="table table-sm table-tp table-borderless table-middle fs-base"
            >
              <thead>
                <tr>
                  <th class="p-0" colspan="2">
                    <h5 class="card-title">Vstupné údaje</h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Distrib. oblasť</td>
                  <td>
                    <b-form-select
                      v-model.lazy="input.distributionArea"
                      v-validate="'required'"
                      class="d-print-none"
                      :class="{ 'is-invalid': errors.has('distributionArea') }"
                      :select-size="1"
                      data-vv-as="Distrib. oblasť"
                      name="distributionArea"
                      @change="inputCalc"
                    >
                      <option :value="null">--Zvolte--</option>
                      <option
                        v-for="(item, key) in selection.distributionArea"
                        :key="key"
                        :value="key"
                      >
                        {{ item }}
                      </option>
                    </b-form-select>
                    <span class="d-none d-print-block">
                      {{ selection.distributionArea[input.distributionArea] }}
                    </span>
                    <b-form-invalid-feedback>
                      {{ errors.first('distributionArea') }}
                    </b-form-invalid-feedback>
                  </td>
                </tr>
                <tr>
                  <td>Napäťová úroveň</td>
                  <td>
                    <b-form-select
                      v-model.lazy="input.voltageVolume"
                      v-validate="'required'"
                      class="d-print-none"
                      :class="{ 'is-invalid': errors.has('voltageVolume') }"
                      :select-size="1"
                      data-vv-as="Napäťová úroveň"
                      name="voltageVolume"
                      @change="inputCalc"
                    >
                      <option :value="null">--Zvolte--</option>
                      <option
                        v-for="(item, key) in selection.voltageVolume"
                        :key="key"
                        :value="key"
                      >
                        {{ item }}
                      </option>
                    </b-form-select>
                    <span class="d-none d-print-block">
                      {{ selection.voltageVolume[input.voltageVolume] }}
                    </span>
                    <b-form-invalid-feedback>
                      {{ errors.first('voltageVolume') }}
                    </b-form-invalid-feedback>
                  </td>
                </tr>
                <tr v-if="ssdNN">
                  <td>Distribučná sadzba</td>
                  <td>
                    <b-form-select
                      v-model.lazy="input.distributionTar"
                      v-validate="'required'"
                      class="d-print-none"
                      :class="{ 'is-invalid': errors.has('distributionTar') }"
                      :select-size="1"
                      data-vv-as="Distribučná sadzba"
                      name="distributionTar"
                      @change="inputCalc"
                    >
                      <option :value="null">--Zvolte--</option>
                      <option
                        v-for="(item, key) in selection.distributionTar"
                        :key="key"
                        :value="key"
                      >
                        {{ item }}
                      </option>
                    </b-form-select>
                    <span class="d-none d-print-block">
                      {{ selection.distributionTar[input.distributionTar] }}
                    </span>
                    <b-form-invalid-feedback>
                      {{ errors.first('distributionTar') }}
                    </b-form-invalid-feedback>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <transition mode="out-in" name="fadeUpShort">
      <b-card v-if="inputReady" class="mb-4" no-body>
        <b-card-body>
          <div class="table-responsive">
            <table class="table table-sm table-tp table-striped table-middle">
              <thead>
                <tr>
                  <th class="p-0 border-bottom-0" colspan="5">
                    <h5 class="card-title">
                      Fakturované položky za silovú elektrinu
                    </h5>
                  </th>
                </tr>
              </thead>
              <thead>
                <tr>
                  <th style="width: 40%">Položky</th>
                  <th class="text-center">Jednotky</th>
                  <th class="text-right">Počet jednotiek</th>
                  <th class="text-right">Jedn. cena (€ bez dph)</th>
                  <th class="text-right">Suma (€ bez dph)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Množstvo VT</td>
                  <td class="text-center">MWh</td>
                  <td>
                    <vue-autonumeric
                      v-model="items.amountVT.amount"
                      :options="{
                        decimalCharacter: ',',
                        digitGroupSeparator: ' ',
                        decimalPlaces: 3,
                        emptyInputBehavior: 'null',
                      }"
                      class="form-control form-control-sm text-right d-print-none"
                    />
                    <span class="text-right d-none d-print-block">{{
                      items.amountVT.amount | formatNumber(3)
                    }}</span>
                  </td>
                  <td>
                    <vue-autonumeric
                      v-model="items.amountVT.unit"
                      :options="{
                        decimalCharacter: ',',
                        digitGroupSeparator: ' ',
                        decimalPlaces: 4,
                        emptyInputBehavior: 'null',
                      }"
                      class="form-control form-control-sm text-right d-print-none"
                    />
                    <span class="text-right d-none d-print-block">{{
                      items.amountVT.unit | formatNumber(3)
                    }}</span>
                  </td>
                  <td class="text-right">
                    <template v-if="items.amountVT.total">
                      {{ items.amountVT.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr v-if="!ssdNNVT">
                  <td>Množstvo NT</td>
                  <td class="text-center">MWh</td>
                  <td>
                    <vue-autonumeric
                      v-model="items.amountNT.amount"
                      :options="{
                        decimalCharacter: ',',
                        digitGroupSeparator: ' ',
                        decimalPlaces: 3,
                        emptyInputBehavior: 'null',
                      }"
                      class="form-control form-control-sm text-right d-print-none"
                    />
                    <span class="text-right d-none d-print-block">{{
                      items.amountNT.amount | formatNumber(3)
                    }}</span>
                  </td>
                  <td>
                    <vue-autonumeric
                      v-model="items.amountNT.unit"
                      :options="{
                        decimalCharacter: ',',
                        digitGroupSeparator: ' ',
                        decimalPlaces: 4,
                        emptyInputBehavior: 'null',
                      }"
                      class="form-control form-control-sm text-right d-print-none"
                    />
                    <span class="text-right d-none d-print-block">{{
                      items.amountNT.unit | formatNumber(3)
                    }}</span>
                  </td>
                  <td class="text-right">
                    <template v-if="items.amountNT.total">
                      {{ items.amountNT.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>Mesačná platba za OM</td>
                  <td class="text-center">mesiac</td>
                  <td>
                    <vue-autonumeric
                      v-model="items.monthlyPayment.amount"
                      v-validate="'required|min_value:1|max_value:12'"
                      :class="{ 'is-invalid': errors.has('monthlyPayment') }"
                      :options="{
                        decimalCharacter: ',',
                        digitGroupSeparator: ' ',
                        decimalPlaces: 0,
                        maximumValue: 12,
                        emptyInputBehavior: 'null',
                      }"
                      class="form-control form-control-sm text-right d-print-none"
                      data-vv-as="Počet mesiacov"
                      name="monthlyPayment"
                    />
                    <span class="text-right d-none d-print-block">{{
                      items.monthlyPayment.amount | formatNumber
                    }}</span>
                    <b-form-invalid-feedback>
                      {{ errors.first('monthlyPayment') }}
                    </b-form-invalid-feedback>
                  </td>
                  <td>
                    <vue-autonumeric
                      v-model="items.monthlyPayment.unit"
                      :options="{
                        decimalCharacter: ',',
                        digitGroupSeparator: ' ',
                        decimalPlaces: 4,
                        emptyInputBehavior: 'null',
                      }"
                      class="form-control form-control-sm text-right d-print-none"
                    />
                    <span class="text-right d-none d-print-block">{{
                      items.monthlyPayment.unit | formatNumber(3)
                    }}</span>
                  </td>
                  <td class="text-right">
                    <template v-if="items.monthlyPayment.total">
                      {{ items.monthlyPayment.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr v-if="totalSupply" class="bg-transparent">
                  <td class="text-right" colspan="5">
                    <h5 class="fs-lg text-primary font-weight-bold">
                      <small class="fs-base"
                        >Celkom za dodávku (€ bez dph):</small
                      >
                      {{ totalSupply | formatNumber(2) }}
                    </h5>
                  </td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th class="pl-0 pt-5 pb-0 border-bottom-0" colspan="5">
                    <h5 class="card-title">
                      Fakturované položky za distribúciu elektriny a regulované
                      poplatky
                    </h5>
                  </th>
                </tr>
              </thead>
              <thead>
                <tr>
                  <th style="width: 40%">Položky</th>
                  <th class="text-center">Jednotky</th>
                  <th class="text-right">Počet jednotiek</th>
                  <th class="text-right">Jedn. cena (€ bez dph)</th>
                  <th class="text-right">Suma (€ bez dph)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!ssdNN">
                  <td>
                    Platba za distribúciu elektriny vrátane prenosu elektriny
                  </td>
                  <td class="text-center">MWh</td>
                  <td class="text-right">
                    <template v-if="amountVTNT">
                      {{ amountVTNT | formatNumber(3) }}
                    </template>
                    <template v-else> - </template>
                  </td>
                  <td class="text-right">
                    {{ distributionTariff | formatNumber(4) }}
                  </td>
                  <td class="text-right">
                    <template v-if="items.distributionPayment.total">
                      {{ items.distributionPayment.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr v-if="ssdNN">
                  <td>
                    Platba za distribúciu elektriny vrátane prenosu elektriny VT
                  </td>
                  <td class="text-center">MWh</td>
                  <td class="text-right">
                    <template v-if="items.amountVT.amount">
                      {{ items.amountVT.amount | formatNumber(3) }}
                    </template>
                    <template v-else> - </template>
                  </td>
                  <td class="text-right">
                    {{ distributionTariff | formatNumber(4) }}
                  </td>
                  <td class="text-right">
                    <template v-if="items.distributionPaymentVT.total">
                      {{ items.distributionPaymentVT.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr v-if="ssdNN && !ssdNNVT">
                  <td>
                    Platba za distribúciu elektriny vrátane prenosu elektriny NT
                  </td>
                  <td class="text-center">MWh</td>
                  <td class="text-right">
                    <template v-if="items.amountNT.amount">
                      {{ items.amountNT.amount | formatNumber(3) }}
                    </template>
                    <template v-else> - </template>
                  </td>
                  <td class="text-right">
                    {{ distributionTariffNT | formatNumber(4) }}
                  </td>
                  <td class="text-right">
                    <template v-if="items.distributionPaymentNT.total">
                      {{ items.distributionPaymentNT.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr v-if="input.voltageVolume === 'nn'">
                  <td>Platba za rezervovanú kapacitu - istič</td>
                  <td v-if="ssdNN">
                    <b-form-select
                      v-model="items.reservedPaymentNN.unit"
                      class="d-print-none"
                      :select-size="1"
                      size="sm"
                    >
                      <option
                        v-for="(item, key) in selection.reservedPaymentNNunit"
                        :key="key"
                        :value="key"
                      >
                        {{ item }}
                      </option>
                    </b-form-select>
                    <span class="d-none text-center d-print-block">
                      {{
                        selection.reservedPaymentNNunit[
                          items.reservedPaymentNN.unit
                        ]
                      }}
                    </span>
                  </td>
                  <td v-else class="text-center">A</td>
                  <td>
                    <div class="d-flex">
                      <b-form-select
                        v-if="items.reservedPaymentNN.unit === 'a'"
                        v-model="items.reservedPaymentNN.phase"
                        class="d-print-none"
                        :select-size="1"
                        size="sm"
                        style="width: 33%"
                      >
                        <option
                          v-for="(
                            item, key
                          ) in selection.reservedPaymentNNphase"
                          :key="key"
                          :value="key"
                        >
                          {{ item }}
                        </option>
                      </b-form-select>
                      <vue-autonumeric
                        v-model="items.reservedPaymentNN.amount"
                        :options="{
                          decimalCharacter: ',',
                          digitGroupSeparator: ' ',
                          decimalPlaces: 3,
                          emptyInputBehavior: 'null',
                        }"
                        class="form-control form-control-sm text-right d-print-none"
                      />
                      <span class="text-right d-none d-print-block">
                        <template v-if="items.reservedPaymentNN.unit !== 'kw'">
                          {{
                            selection.reservedPaymentNNphase[
                              items.reservedPaymentNN.phase
                            ]
                          }}
                          -
                        </template>
                        {{
                          items.reservedPaymentNN.amount | formatNumber(3)
                        }}</span
                      >
                    </div>
                  </td>
                  <td class="text-right">
                    {{ accessTariff | formatNumber(4) }}
                  </td>
                  <td class="text-right">
                    <template v-if="items.reservedPaymentNN.total">
                      {{ items.reservedPaymentNN.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr v-else>
                  <td>
                    <b-form-select
                      v-model="items.reservedPayment.type"
                      class="d-print-none"
                      :select-size="1"
                      size="sm"
                    >
                      <option
                        v-for="(item, key) in selection.reservedPaymentType"
                        :key="key"
                        :value="key"
                      >
                        {{ item }}
                      </option>
                    </b-form-select>
                    <span class="d-none d-print-block">
                      {{
                        selection.reservedPaymentType[
                          items.reservedPayment.type
                        ]
                      }}
                    </span>
                  </td>
                  <td class="text-center">kW</td>
                  <td>
                    <vue-autonumeric
                      v-model="items.reservedPayment.amount"
                      :options="{
                        decimalCharacter: ',',
                        digitGroupSeparator: ' ',
                        decimalPlaces: 3,
                        emptyInputBehavior: 'null',
                      }"
                      class="form-control form-control-sm text-right d-print-none"
                    />
                    <span class="text-right d-none d-print-block">{{
                      items.reservedPayment.amount | formatNumber(3)
                    }}</span>
                  </td>
                  <td class="text-right">
                    {{ monthlyTariff | formatNumber(4) }}
                  </td>
                  <td class="text-right">
                    <template v-if="items.reservedPayment.total">
                      {{ items.reservedPayment.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>Platba za straty pri distribúcii</td>
                  <td class="text-center">MWh</td>
                  <td class="text-right">
                    <template v-if="amountVTNT">
                      {{ amountVTNT | formatNumber(3) }}
                    </template>
                    <template v-else> - </template>
                  </td>
                  <td class="text-right">
                    {{ lossTariff | formatNumber(4) }}
                  </td>
                  <td class="text-right">
                    <template v-if="items.lossPayment.total">
                      {{ items.lossPayment.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>
                    Platba za prevádzkovanie systému ({{
                      items.operationPayment.type
                    }})
                  </td>
                  <td class="text-center">MWh</td>
                  <td class="text-right">
                    <template v-if="amountVTNT">
                      {{ amountVTNT | formatNumber(3) }}
                    </template>
                    <template v-else> - </template>
                  </td>
                  <td class="text-right">
                    {{ tps() | formatNumber(4) }}
                  </td>
                  <td class="text-right">
                    <template v-if="items.operationPayment.total">
                      {{ items.operationPayment.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>
                    <template v-if="year < 2025">
                      Platba za systémové služby
                    </template>
                    <template v-else>
                      <b-form-select
                        v-model="items.servicePayment.type"
                        class="d-print-none"
                        :select-size="1"
                        size="sm"
                      >
                        <option
                          v-for="(item, key) in selection.systemServicePayment"
                          :key="key"
                          :value="key"
                        >
                          {{ item }}
                        </option>
                      </b-form-select>
                      <span class="d-none d-print-block">
                        {{
                          selection.systemServicePayment[
                            items.servicePayment.type
                          ]
                        }}
                      </span>
                    </template>
                  </td>
                  <td class="text-center">MWh</td>
                  <td class="text-right">
                    <template v-if="amountVTNT">
                      {{ amountVTNT | formatNumber(3) }}
                    </template>
                    <template v-else> - </template>
                  </td>
                  <td class="text-right">
                    {{ systemTariff | formatNumber(4) }}
                  </td>
                  <td class="text-right">
                    <template v-if="items.servicePayment.total">
                      {{ items.servicePayment.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>Odvod do jadrového fondu</td>
                  <td class="text-center">MWh</td>
                  <td class="text-right">
                    <template v-if="amountVTNT">
                      {{ amountVTNT | formatNumber(3) }}
                    </template>
                    <template v-else> - </template>
                  </td>
                  <td class="text-right">
                    {{ findPrice('njf') | formatNumber(4) }}
                  </td>
                  <td class="text-right">
                    <template v-if="items.fundPayment.total">
                      {{ items.fundPayment.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>Platba za nevyžiadanú dodávku jalovej energie</td>
                  <td class="text-center">kVArh</td>
                  <td>
                    <vue-autonumeric
                      v-model="items.idlePayment.amount"
                      :options="{
                        decimalCharacter: ',',
                        digitGroupSeparator: ' ',
                        decimalPlaces: 3,
                        emptyInputBehavior: 'null',
                      }"
                      class="form-control form-control-sm text-right d-print-none"
                    />
                    <span class="text-right d-none d-print-block">{{
                      items.idlePayment.amount | formatNumber(3)
                    }}</span>
                  </td>
                  <td class="text-right">
                    {{ distributionFee | formatNumber(4) }}
                  </td>
                  <td class="text-right">
                    <template v-if="items.idlePayment.total">
                      {{ items.idlePayment.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b-form-checkbox
                      v-model="applyTax"
                      class="d-print-none"
                      title="Zahrnúť do výpočtu"
                      @change="calc"
                    >
                      Spotrebná daň
                    </b-form-checkbox>
                    <div class="text-muted fs-sm">
                      Možnosť nefakturovať v prípade Oslobodenia od spotrebnej
                      dane z elektriny, uhlia a zemného plynu
                    </div>
                  </td>
                  <td class="text-center">MWh</td>
                  <td class="text-right">
                    <template v-if="applyTax && amountVTNT">
                      {{ amountVTNT | formatNumber(3) }}
                    </template>
                    <template v-else> - </template>
                  </td>
                  <td class="text-right">
                    {{
                      applyTax
                        ? findPrice('consumption_tax')
                        : 0 | formatNumber(4)
                    }}
                  </td>
                  <td class="text-right">
                    <template v-if="items.consumptionTax.total">
                      {{ items.consumptionTax.total | formatNumber(2) }}
                    </template>
                    <template v-else>
                      <b-icon class="text-muted" icon="question-circle" />
                    </template>
                  </td>
                </tr>
                <tr v-if="totalDistribution" class="bg-transparent">
                  <td class="text-right border-0" colspan="5">
                    <h5 class="fs-lg text-primary font-weight-bold">
                      <small class="fs-base"
                        >Celkom za distribúciu elektriny a regulované poplatky
                        (€ bez dph):</small
                      >
                      {{ totalDistribution | formatNumber(2) }}
                    </h5>
                  </td>
                </tr>
                <tr v-if="totalSupplyDist" class="bg-transparent">
                  <td class="text-right pt-3" colspan="5">
                    <h5 class="fs-lg text-primary font-weight-bold">
                      <small class="fs-base">Celkom (€ bez dph):</small>
                      {{ totalSupplyDist | formatNumber(2) }}
                    </h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <b-alert
            v-if="
              (items.monthlyPayment.amount == 1 ||
                items.monthlyPayment.amount == 12) &&
              recDeposit
            "
            show
            variant="primary"
          >
            <h4 class="font-weight-bold text-center mb-0 final-result">
              Odporúčaná výška mesačnej zálohovej platby s DPH:
              <strong>{{ recDeposit | formatNumber(2) }} €</strong>
            </h4>
          </b-alert>
        </b-card-body>
      </b-card>
    </transition>
  </div>
</template>
<script>
import getPrices from '../mixins/getPrices'

export default {
  mixins: [getPrices],
  props: {
    year: {
      type: [String, Number],
    },
  },
  data() {
    return {
      loading: false,
      pricelist: [],
      input: {
        distributionArea: null,
        voltageVolume: null,
        distributionTar: null,
      },
      items: {
        amountVT: { amount: null, unit: null, total: null },
        amountNT: { amount: null, unit: null, total: null },
        monthlyPayment: { amount: null, unit: null, total: null },
        distributionPayment: { total: null },
        distributionPaymentVT: { total: null },
        distributionPaymentNT: { total: null },
        reservedPayment: { type: 1, amount: null, total: null },
        reservedPaymentNN: { unit: 'a', phase: 1, amount: null, total: null },
        lossPayment: { total: null },
        operationPayment: { type: '', total: null },
        servicePayment: { type: 1, total: null },
        fundPayment: { total: null },
        idlePayment: { amount: null, total: null },
        consumptionTax: { total: null },
      },
      totalSupply: null,
      amountVTNT: null,
      totalDistribution: null,
      totalSupplyDist: null,
      recDeposit: null,
      applyTax: false,
    }
  },
  computed: {
    selection() {
      let tariff = {}
      for (let i = 1; i < 9; i++) {
        tariff[`c${i}`] = `C${i}`
      }
      tariff.c10 = 'C10'
      tariff.c12 = 'C12'

      return {
        distributionArea: {
          vsd: 'VSD',
          ssd: 'SSD',
          zsdis: 'ZSDIS',
        },
        voltageVolume: {
          vn: 'VN',
          nn: 'NN',
        },
        distributionTar: tariff,
        reservedPaymentNNunit: {
          a: 'A',
          kw: 'kW',
        },
        reservedPaymentNNphase: {
          [this.zsdisOrSSD ? 3 : 1]: '3f',
          [this.zsdisOrSSD ? 1 : 3]: '1f',
        },
        reservedPaymentType: {
          1: 'Platba za rezervovanú kapacitu (1 mes.)',
          3: 'Platba za rezervovanú kapacitu (3 mes.)',
          12: 'Platba za rezervovanú kapacitu (12 mes.)',
        },
        systemServicePayment: {
          1: 'Platba za systémové služby (TSS1)',
          2: 'Platba za systémové služby (TSS2)',
          3: 'Platba za systémové služby (TSS3)',
          4: 'Platba za systémové služby (TSS4)',
        },
      }
    },
    distributionTariff() {
      if (this.ssdNN) {
        return this.findByInput(
          `distribution_tariff_nn_ssd_${this.input.distributionTar}_vt`,
        )
      }
      return this.findByInput(
        `distribution_tariff_${this.input.voltageVolume}_${this.input.distributionArea}`,
      )
    },
    distributionTariffNT() {
      return this.findByInput(
        `distribution_tariff_nn_ssd_${this.input.distributionTar}_nt`,
      )
    },
    monthlyTariff() {
      return this.findByInput(
        `monthly_tariff_rc_${this.input.voltageVolume}${this.items.reservedPayment.type}_${this.input.distributionArea}`,
      )
    },
    accessTariff() {
      if (this.input.distributionArea === 'ssd') {
        return this.findByInput(
          `access_tariff_nn_${this.input.distributionArea}_${this.input.distributionTar}_${this.items.reservedPaymentNN.unit}`,
        )
      }
      return this.findByInput(`access_tariff_nn_${this.input.distributionArea}`)
    },
    distributionFee() {
      return this.findByInput(`distribution_fee_${this.input.distributionArea}`)
    },
    lossTariff() {
      return this.findByInput(
        `loss_tariff_${this.input.voltageVolume}_${this.input.distributionArea}`,
      )
    },
    systemTariff() {
      return this.year < 2025
        ? this.findPrice('tss')
        : this.findByInput(
            `system_service_tariff_tss${this.items.servicePayment.type}`,
          )
    },
    zsdisOrSSD() {
      return (
        this.input.distributionArea === 'zsdis' ||
        this.input.distributionArea === 'ssd'
      )
    },
    ssdNN() {
      return (
        this.input.distributionArea === 'ssd' &&
        this.input.voltageVolume === 'nn'
      )
    },
    ssdNNNT() {
      return (
        this.ssdNN &&
        (this.input.distributionTar === 'c4' ||
          this.input.distributionTar === 'c5' ||
          this.input.distributionTar === 'c6' ||
          this.input.distributionTar === 'c7' ||
          this.input.distributionTar === 'c8')
      )
    },
    ssdNNVT() {
      return (
        this.ssdNN &&
        (this.input.distributionTar === 'c1' ||
          this.input.distributionTar === 'c2' ||
          this.input.distributionTar === 'c3' ||
          this.input.distributionTar === 'c10')
      )
    },
    inputReady() {
      return (
        (!this.ssdNN &&
          this.input.distributionArea &&
          this.input.voltageVolume) ||
        (this.ssdNN && this.input.distributionTar)
      )
    },
    tax() {
      return this.year >= 2025 ? 1.19 : 1.2
    },
  },
  watch: {
    items: {
      deep: true,
      handler() {
        this.calc()
      },
    },
    year() {
      this.fetchPrices(true)
    },
  },
  created() {
    this.fetchPrices()
  },
  methods: {
    fetchPrices(calc = false) {
      this.getPrices(
        [
          'distribution_fee',
          'monthly_tariff_rc',
          'tps',
          'tss',
          'system_service_tariff',
          'njf',
          'consumption_tax',
          'distribution_tariff',
          'loss_tariff',
          'access_tariff',
        ],
        calc,
      )
    },
    inputCalc() {
      this.items.reservedPaymentNN.unit = 'a'

      if (this.inputReady && (this.totalSupply || this.totalDistribution)) {
        this.resetItems()
      }
    },
    calc() {
      let amountVT = this.items.amountVT
      if (amountVT.amount && amountVT.unit) {
        amountVT.total = amountVT.amount * amountVT.unit
      } else {
        amountVT.total = null
      }
      let amountNT = this.items.amountNT
      if (amountNT.amount && amountNT.unit) {
        amountNT.total = amountNT.amount * amountNT.unit
      } else {
        amountNT.total = null
      }
      let monthlyPayment = this.items.monthlyPayment
      monthlyPayment.total = monthlyPayment.amount * monthlyPayment.unit

      this.totalSupply = amountVT.total + amountNT.total + monthlyPayment.total

      this.amountVTNT = amountVT.amount + amountNT.amount

      let distributionPayment = this.items.distributionPayment
      if (!this.ssdNN) {
        distributionPayment.total = this.amountVTNT * this.distributionTariff
      } else {
        this.items.distributionPaymentVT.total =
          amountVT.amount * this.distributionTariff
        this.items.distributionPaymentNT.total =
          amountNT.amount * this.distributionTariffNT
      }

      let reservedPayment = this.items.reservedPayment
      reservedPayment.total =
        reservedPayment.amount * this.monthlyTariff * monthlyPayment.amount

      let reservedPaymentNN = this.items.reservedPaymentNN
      let phaseVal = null
      if (
        this.input.distributionArea === 'zsdis' ||
        this.input.distributionArea === 'ssd'
      ) {
        phaseVal = reservedPaymentNN.amount * reservedPaymentNN.phase
      } else {
        phaseVal = reservedPaymentNN.amount / reservedPaymentNN.phase
      }
      reservedPaymentNN.total =
        (this.items.reservedPaymentNN.unit === 'a'
          ? phaseVal
          : reservedPaymentNN.amount) *
        this.accessTariff *
        monthlyPayment.amount

      this.items.lossPayment.total = this.amountVTNT * this.lossTariff
      this.items.operationPayment.total = this.amountVTNT * this.tps()
      this.items.servicePayment.total = this.amountVTNT * this.systemTariff
      this.items.fundPayment.total = this.amountVTNT * this.findPrice('njf')
      let idlePayment = this.items.idlePayment
      idlePayment.total = idlePayment.amount * this.distributionFee
      if (this.applyTax) {
        this.items.consumptionTax.total =
          this.amountVTNT * this.findPrice('consumption_tax')
      } else {
        this.items.consumptionTax.total = 0
      }

      this.totalDistribution =
        distributionPayment.total +
        this.items.distributionPaymentVT.total +
        this.items.distributionPaymentNT.total +
        reservedPayment.total +
        reservedPaymentNN.total +
        this.items.lossPayment.total +
        this.items.operationPayment.total +
        this.items.servicePayment.total +
        this.items.fundPayment.total +
        idlePayment.total +
        this.items.consumptionTax.total
      this.totalSupplyDist = this.totalSupply + this.totalDistribution
      this.recDeposit =
        (this.totalSupplyDist / monthlyPayment.amount) * this.tax
    },
    findByInput(input) {
      if (this.input.voltageVolume && this.input.distributionArea) {
        let price = this.pricelist.find((price) => price.name === input)
        if (price) {
          return price.values ? price.values.value : null
        }
      }
      return null
    },
    findPrice(name) {
      let price = this.pricelist.find((price) => price.name === name)
      if (price) {
        return price.values?.value
      }
    },
    tps() {
      switch (this.year) {
        case 2021:
          this.items.operationPayment.type = 'TPS1'
          return this.findPrice('tps')
        default:
          if (this.amountVTNT <= 1000) {
            this.items.operationPayment.type = 'TPS1'
            return this.findPrice('tps1')
          } else if (this.amountVTNT > 1000 && this.amountVTNT <= 100000) {
            this.items.operationPayment.type = 'TPS2'
            return this.findPrice('tps2')
          } else if (this.amountVTNT > 100000) {
            this.items.operationPayment.type = 'TPS3'
            return this.findPrice('tps3')
          }
      }
    },
    reset() {
      Object.assign(this.$data, this.$options.data())
      this.fetchPrices()
    },
    resetItems() {
      Object.assign(this.items, this.$options.data().items)
    },
  },
}
</script>
